import React from 'react';
import Root from 'react-modal-sheet';
import { styled } from '@components-shared/src/stitches';

export function Sheet({
  children,
  ...props
}: { children: React.ReactNode } & React.ComponentProps<typeof Root>) {
  const {
    disableDrag = false,
    onClose,
    snapPoints = [0.8],
    springConfig = { damping: 40, stiffness: 400 },
  } = props;
  return (
    <Root {...props} disableDrag={disableDrag} snapPoints={snapPoints} springConfig={springConfig}>
      <Backdrop onTap={onClose} />
      {children}
    </Root>
  );
}

export function SheetContainer({
  children,
  hasThumb = false,
  ...props
}: { children: React.ReactNode; hasThumb?: boolean } & React.ComponentProps<
  typeof Root.Container
>) {
  return (
    <StyledSheetContainer {...props}>
      {hasThumb && <Thumb />}
      <SheetContent>{children}</SheetContent>
    </StyledSheetContainer>
  );
}

const SheetContent = styled(Root.Content, {
  height: '100% ',
  overflow: 'visible',
});

const Backdrop = styled(Root.Backdrop, {
  background: 'rgba(0, 0, 0, 0.7)',
});

const StyledSheetContainer = styled(Root.Container, {
  position: 'relative',
  borderTopLeftRadius: '$extraLarge',
  borderTopRightRadius: '$extraLarge',
  overflow: 'hidden',
});

const Thumb = styled('div', {
  position: 'absolute',
  top: 8,
  left: '50%',
  transform: 'translateX(-50%)',
  width: 40,
  height: 4,
  background: '$base300',
  borderRadius: '$extraLarge',
  zIndex: '$above1',
});

Sheet.Content = SheetContainer;
